import { render, staticRenderFns } from "./ToeflPrimaryStep1ScoreComponent.vue?vue&type=template&id=751f2a8e&scoped=true&"
import script from "./ToeflPrimaryStep1ScoreComponent.vue?vue&type=script&lang=js&"
export * from "./ToeflPrimaryStep1ScoreComponent.vue?vue&type=script&lang=js&"
import style0 from "./ToeflPrimaryStep1ScoreComponent.vue?vue&type=style&index=0&id=751f2a8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751f2a8e",
  null
  
)

export default component.exports